import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AccountCircle from '@material-ui/icons/AccountCircle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import LineIcon from '@material-ui/icons/ShortText';
import logo from '../lplogo_header.png';
import logoHD from '../leaseplan_logo_HDD2.png';
import negotiationIcon from '../Icons/meetingW.svg';
import negotiationIconHover from '../Icons/meetingB.svg';
import firmPurchasesIcon from '../Icons/flyerW.svg';
import firmPurchasesIconHover from '../Icons/flyerB.svg';
import transportIcon from '../Icons/transportW.svg';
import transportIconHover from '../Icons/transportB.svg';
import reservationsIcon from '../Icons/handshakeW.svg';
import reservationsIconHover from '../Icons/handshakeB.svg';
import reportsIcon from '../Icons/resumeW.svg';
import reportsIconHover from '../Icons/resumeB.svg';
import auditIcon from '../Icons/auditW.svg';
import auditIconHover from '../Icons/auditB.svg';
import adminIcon from '../Icons/processW.svg';
import adminIconHover from '../Icons/processB.svg';
import reservationsRUIcon from '../Icons/dealW.svg';
import reservationsRUIconHover from '../Icons/dealB.svg';
import { NegotiationContent } from './Negotiation/NegotiationContent';
import { FirmPurchasesContent } from './FirmPurchases/FirmPurchasesContent';
import { TransportsContent } from './Transports/TransportsContent';
import { ReservationsContent } from './Reservations/ReservationsContent';
import { ReportsContent } from './Reports/ReportsContent';
import { AdminSalesForceAuditBMSFContent } from './Administration/AdminSalesForceAudit/AdminSalesForceAuditBMSFContent';
import { AdminSalesForceAuditSFBMContent } from './Administration/AdminSalesForceAudit/AdminSalesForceAuditSFBMContent';
import { AdminBrandModelContent } from './Administration/AdminBrandModel/AdminBrandModelContent';
import { AdminSaleChannelContent } from './Administration/AdminSaleChannels/AdminSaleChannelContent';
import { AdminDiscountsContent } from './Administration/AdminDiscounts/AdminDiscountsContent';
import { AdminOptionalsContent } from './Administration/AdminOptionals/AdminOptionalsContent';
import { AdminGeneralDefinitionsContent } from './Administration/AdminGeneralDefinitions/AdminGeneralDefinitionsContent';
import { AdminHolidaysContent } from './Administration/AdminHolidays/AdminHolidaysContent';
import { AdminColorsContent } from './Administration/AdminColor/AdminColorsContent';
import { AdminColorsSalesForceContent } from './Administration/AdminColorSF/AdminColorsSalesForceContent';
import { AdminExtensionContent } from './Administration/AdminExtension/AdminExtensionContent';
import { AdminCancellationContent } from './Administration/AdminCancellation/AdminCancellationContent';
import { AdminSalesForceSyncContent } from './Administration/AdminSalesForceSync/AdminSalesForceSyncContent';
import { RUCreationContent } from './UsedRentals/UsedRentalsCreation/RUCreationContent';
import { RUManagementContent } from './UsedRentals/UsedRentalsManagement/RUManagementContent';
import { RUTransportsContent } from './UsedRentals/UsedRentalsTransport/RUTransportsContent';
import { RUReservationsContent } from './UsedRentals/UsedRentalsReservations/RUReservationsContent';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { logOut } from '../store/actions/login/loginActions';
import grey from '@material-ui/core/colors/grey';
import deepOrange from '@material-ui/core/colors/deepOrange';
import 'typeface-roboto';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import UserRoleApi from '../API/UserRoleAPI';
import { ADMIN_GROUP, FP_NEGOTIATION_GROUP, FP_GROUP, FP_COMMERCIAL_GROUP, REPORTS_GROUP, REPORTS_GLOBAL_GROUP,
  GENERAL_GROUP, UR_CREATION_GROUP, UR_GROUP, UR_COMMERCIAL_GROUP, UR_GENERAL_GROUP, AUDIT_BMSF, AUDIT_SFBM, FONT_FAMILY_TYPOGRAPHY } from '../Utils/Constants';
import { clearLoginInterval, onUnload, setLoginInterval } from '../Utils/Timer';

const borderColor = {
    borderBottomColor: "#577180"
}

const drawerWidth = 300;

const deepOrangePalette = createMuiTheme({
    palette: {
        primary: deepOrange,
        secondary: grey,
    },
    typography: FONT_FAMILY_TYPOGRAPHY
});

const steelpalette = createMuiTheme({
  palette: {
    primary: {
      light: '#a7a7a7',
      main: '#545656',
      dark: '#3a3c3c',
      contrastText: '#ffffff'
    },
    secondary: grey,
  },
  typography: FONT_FAMILY_TYPOGRAPHY
});

const grassGreenpalette = createMuiTheme({
  palette: {
    primary: {
      light: '#7bcb87',
      main: '#009A17',
      dark: '#006b10',
      contrastText: '#ffffff'
    },
    secondary: grey,
  },
  typography: FONT_FAMILY_TYPOGRAPHY
});

const freshGreenPalette = createMuiTheme({
  palette: {
    primary: {
      light: '#d2e283',
      main: '#A9C90E',
      dark: '#768c09',
      contrastText: '#ffffff'
    },
    secondary: grey,
  },
  typography: FONT_FAMILY_TYPOGRAPHY
});

const styles = theme => ({
  appRoot: {
    flexGrow: 1,
    zIndex: 1,
    position: 'relative',
    display: 'flex',
    width: '100%'
  },
  typoFlex: {
    flex: 1,
    marginLeft: '32px'
  },
  usernameMargin: {
    margin: '0px 12px'
  },
  textWhite: {
    color: '#ffffff'
  },
  initialScreenLogo: {
    opacity: 0.4,
    position: 'absolute',
    margin: 'auto',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
  appBar: {
    backgroundColor: '#FFFFFF',
    color: "#73D2D2",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
  },
  menuButton: {
    margin: '0px 82px 0 12px',
    '&:hover': {
        backgroundColor: "#B9E9E9"
      },
  },
  hide: {
    display: 'none'
  },
  drawerPaper: {
    height: 'auto',
    minHeight: '100vh',
    backgroundColor: theme.palette.primary.main,
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
  },
  drawerPaperClose: {
    overflow: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    backgroundColor: 'theme.palette.background.default',
    padding: theme.spacing.unit
  },
  divID: {
    display: 'flex',
    marginRight: 24
  },
  iconSize: {
    height: '24px'
  },
  nested: {
    padding: '6px 0px 6px 48px'
  },
  hoverLI: {
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
  },
  selected: {
    backgroundColor: "#73D2D2"
  },
  bgColor: {
    backgroundColor: theme.palette.primary.main
  },
  toolbarHeight: {
    minHeight: '52px'
  },
  hideTitle: {
    visibility: 'hidden',
  },
  textModuleTitle: {
    color: 'white',
    fontWeight: 'bold'
  },
  menuDivider: {
    width: '66%',
    height: '2px',
    margin: '48px auto 0px auto',
    backgroundColor: "#73D2D2"
  },
  menuDividerOpen: {
    width: '80%',
    height: '2px',
    margin: '24px auto 24px auto',
    backgroundColor: "#73D2D2"
  }
});

class GCFMainApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: props.user,
      titleTableList: '',
      showContent: '',
      anchorEl: null,
    };
  }
  state = {
    open: false,
    openAdminList: false,
    clickAdmin: false,
  };

  componentDidMount() {
    this.setState({ anchorEl: null });
    setLoginInterval(this.state.user.UserName);
    
    window.addEventListener('beforeunload', onUnload);
  }

  componentWillUnmount() {
    this.setState({ anchorEl: null });
    window.removeEventListener('beforeunload', onUnload); 
  }

  handleClickOpenLogout = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleCloseLogout = () => {
    this.setState({ anchorEl: null });
  };

  cleanCookie = () => {
    clearLoginInterval();

    const userRoleApi = new UserRoleApi();
    userRoleApi.logout(this.state.user.UserName).then(ok => {
      this.props.logOut();
    }
    ).catch(err => console.log(err))

    this.setState({ anchorEl: null })
  }


  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false, openAdminList: false, clickAdmin: false });
  };

  handleChangeAdminList = () => {
    if (!this.state.openAdminList) {
        document.querySelectorAll('[role="tooltip"]').forEach(function(el) {
            el.style.display = "none"
        });
        this.setState({ open: true, openAdminList: true, clickAdmin: true });
    } else
        this.setState({ open: true, openAdminList: false, clickAdmin: true });
  };


  changeColor = (event, icon, color) => {
    event.currentTarget.children[0].src = icon;
    event.currentTarget.children[1].style.color = color;
  }

  changeColorAdmin = (event, icon, color, colorIcon, mouseOut, mouseOver) => {
    event.currentTarget.children[0].src = icon;
    event.currentTarget.children[1].style.color = color;
    event.currentTarget.children[2].color = colorIcon;
    if (!this.state.open && mouseOver) 
        document.querySelectorAll('[role="tooltip"]').forEach(function(el) {
            el.style.display = "block"
        });

    this.setState({
        clickAdmin: mouseOut ? false : true,
    });
  }

  changeColorText = (event, color) => {
    event.currentTarget.children[0].style.color = color;
    event.currentTarget.children[1].style.color = color;
  }

  showNegotiation = () => {
    this.setState({
      showContent: 'negotiation',
      titleTableList: 'LOTES EM NEGOCIAÇÃO',
      clickAdmin: false
    });
  };
  showFirmPurchases = () => {
    this.setState({
      showContent: 'firmPurchases',
      titleTableList: 'LOTES COMPRAS FIRMES',
      clickAdmin: false
    });
  };

  showTransports = () => {
    this.setState({ showContent: 'transports', clickAdmin: false });
  };
  showReservations = () => {
    this.setState({ showContent: 'reservations', clickAdmin: false });
  };
  showCreationUsedRentals = () => {
    this.setState({
      showContent: 'creationUsedRentals',
      titleTableList: 'CRIAÇÃO LOTES RENTING USADOS',
      clickAdmin: false
    });
  };
  showUsedRentals = () => {
    this.setState({
      showContent: 'usedRentals',
      titleTableList: 'LOTES RENTING USADOS',
      clickAdmin: false
    });
  };
  showTransportsUsedRentals = () => {
    this.setState({ showContent: 'transportsUsedRentals', clickAdmin: false });
  };
  showReservationsUsedRentals = () => {
    this.setState({ showContent: 'reservationsUsedRentals', clickAdmin: false });
  };
  showReports = () => {
    this.setState({ showContent: 'reports', clickAdmin: false });
  };
  showAuditSFBM = () => {
    this.setState({
      showContent: 'auditSFBM',
      titleTableList: 'TABELA DE AUDIT - SalesForce -> BM',
      clickAdmin: false
    });
  };
  showAuditBMSF = () => {
    this.setState({
      showContent: 'auditBMSF',
      titleTableList: 'TABELA DE AUDIT - BM -> SalesForce',
      clickAdmin: false
    });
  };
  showAdminBrandModel = () => {
    this.setState({
      showContent: 'adminBrandModel',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - MARCAS E MODELOS',
      clickAdmin: false
    });
  };
  showAdminSaleChannel = () => {
    this.setState({
      showContent: 'adminSaleChannel',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - CANAIS DE VENDA',
      clickAdmin: false
    });
  };
  showAdminDiscounts = () => {
    this.setState({
      showContent: 'adminDiscounts',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - DESCONTOS',
      clickAdmin: false
    });
  };
  showAdminOptionals = () => {
    this.setState({
      showContent: 'adminOptionals',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - OPCIONAIS',
      clickAdmin: false
    });
  };
  showAdminGeneralDefinitions = () => {
    this.setState({
      showContent: 'adminGeneralDefinitions',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - DEFINIÇÕES GERAIS',
      clickAdmin: false
    });
  };
  showAdminHolidays = () => {
    this.setState({
      showContent: 'adminHolidays',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - FERIADOS',
      clickAdmin: false
    });
  };
  showAdminColors = () => {
    this.setState({
      showContent: 'adminColors',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - CORES',
      clickAdmin: false
    });
  };
  showAdminColorsSF = () => {
    this.setState({
      showContent: 'adminColorsSF',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - MATRIZ CORES SALES FORCE',
      clickAdmin: false
    });
  };
  showAdminExtension = () => {
    this.setState({
      showContent: 'adminExtension',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - MOTIVOS DE PROLONGAMENTO DE RESERVA',
      clickAdmin: false
    });
  };
  showAdminCancellation = () => {
    this.setState({
      showContent: 'adminCancellation',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - MOTIVOS DE CANCELAMENTO DE RESERVA',
      clickAdmin: false
    });
  };
  showAdminSalesForceSync = () => {
    this.setState({
      showContent: 'adminSalesForceSync',
      titleTableList: 'TABELA DE ADMINISTRAÇÃO - ENVIOS SALESFORCE',
      clickAdmin: false
    });
  };

  render() {
    const { classes, theme } = this.props;
    let content = null;
    switch (this.state.showContent) {
      case 'negotiation':
        content = (<MuiThemeProvider theme={deepOrangePalette}><NegotiationContent titleTableList={this.state.titleTableList} showContent={this.state.showContent} /></MuiThemeProvider>);
        break;
      case 'firmPurchases':
        content = (<FirmPurchasesContent titleTableList={this.state.titleTableList} showContent={this.state.showContent} />);
        break;
      case 'transports':
        content = (<MuiThemeProvider theme={freshGreenPalette}><TransportsContent showContent={this.state.showContent} /></MuiThemeProvider>);
        break;
      case 'reservations':
        content = (<ReservationsContent />);
        break;
      case 'reports':
        content = (<MuiThemeProvider theme={grassGreenpalette}><ReportsContent roleTypes={this.props.roleTypes} /></MuiThemeProvider>);
        break;
      case 'auditBMSF':
        content = (<MuiThemeProvider theme={steelpalette}><AdminSalesForceAuditBMSFContent titleTableList={this.state.titleTableList} tableList={AUDIT_BMSF} /></MuiThemeProvider>);
        break;
      case 'auditSFBM':
        content = (<MuiThemeProvider theme={steelpalette}><AdminSalesForceAuditSFBMContent titleTableList={this.state.titleTableList} tableList={AUDIT_SFBM} /></MuiThemeProvider>);
        break;
      case 'adminBrandModel':
        content = (<MuiThemeProvider theme={steelpalette}><AdminBrandModelContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminSaleChannel':
        content = (<MuiThemeProvider theme={steelpalette}><AdminSaleChannelContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminDiscounts':
        content = (<MuiThemeProvider theme={steelpalette}><AdminDiscountsContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminOptionals':
        content = (<MuiThemeProvider theme={steelpalette}><AdminOptionalsContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminGeneralDefinitions':
        content = (<MuiThemeProvider theme={steelpalette}><AdminGeneralDefinitionsContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminHolidays':
        content = (<MuiThemeProvider theme={steelpalette}><AdminHolidaysContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminColors':
        content = (<MuiThemeProvider theme={steelpalette}><AdminColorsContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminColorsSF':
        content = (<MuiThemeProvider theme={steelpalette}><AdminColorsSalesForceContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminExtension':
        content = (<MuiThemeProvider theme={steelpalette}><AdminExtensionContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminCancellation':
        content = (<MuiThemeProvider theme={steelpalette}><AdminCancellationContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
        break;
      case 'adminSalesForceSync':
          content = (<MuiThemeProvider theme={steelpalette}><AdminSalesForceSyncContent titleTableList={this.state.titleTableList} /></MuiThemeProvider>);
          break;
      case 'creationUsedRentals':
        content = (<MuiThemeProvider theme={deepOrangePalette}><RUCreationContent titleTableList={this.state.titleTableList} showContent={this.state.showContent} /></MuiThemeProvider>);
        break;
      case 'usedRentals':
        content = (<RUManagementContent titleTableList={this.state.titleTableList} showContent={this.state.showContent} />);
        break;
      case 'transportsUsedRentals':
        content = (<MuiThemeProvider theme={freshGreenPalette}><RUTransportsContent showContent={this.state.showContent} /></MuiThemeProvider>);
        break;
      case 'reservationsUsedRentals':
        content = (<RUReservationsContent />);
        break;
      default:
        content = (<MuiThemeProvider theme={steelpalette}><img src={logoHD} className={classes.initialScreenLogo} alt='LeasePlan Logo' /></MuiThemeProvider>);
        break;
    }
    return (
      <div className={classes.appRoot}>

        <AppBar className={classNames(classes.appBar, this.state.open && classes.appBarShift)} >
          <Toolbar disableGutters={!this.state.open} classes={{ root: classes.toolbarHeight }}>

            <IconButton color='primary' aria-label='open drawer' className={classNames(classes.menuButton, this.state.open && classes.hide)} onClick={this.handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            <img src={logo} alt='LeasePlan Logo' height='32' />

            <Typography variant='title' color='primary' align='left' className={classes.typoFlex}>
              BULK MANAGER
            </Typography>

            <AccountCircle />
            <Typography variant='body1' className={classes.usernameMargin} >
              <Button
                aria-owns={this.state.anchorEl ? 'simple-menu' : undefined}
                aria-haspopup='true'
                onClick={this.handleClickOpenLogout}
              >
                {this.state.user.UserDisplayName}
              </Button>
              <Menu
                id='simple-menu'
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={this.handleCloseLogout}
              >
                <MenuItem onClick={() => this.cleanCookie()}>Logout</MenuItem>
              </Menu>
            </Typography>

          </Toolbar>
        </AppBar>

        <Drawer variant='permanent' open={this.state.open} classes={{ paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose), docked: classes.bgColor }} >
          <div className={classNames(classes.toolbar, classes.toolbarHeight)}>
            <IconButton className={classes.textWhite} color='inherit' onClick={this.handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>

          <List>
            <div>
              {this.props.roleTypes.indexOf(FP_NEGOTIATION_GROUP) > -1 || this.props.roleTypes.indexOf(FP_GROUP) > -1
                || this.props.roleTypes.indexOf(FP_COMMERCIAL_GROUP) > -1 || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 ?
                <ListItem className={this.state.open ? '' : classes.hideTitle}>
                  <ListItemText disableTypography primary='Gestão de Compras Firmes' className={this.state.open ? classes.textModuleTitle : classes.hideTitle} />
                </ListItem>
                : null}

              {this.props.roleTypes.indexOf(FP_NEGOTIATION_GROUP) > -1 || this.props.roleTypes.indexOf(FP_GROUP) > -1 || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 ?
                <Tooltip title='Negociação Compras Firmes' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                  <ListItem onMouseOver={(e) => this.changeColor(e, negotiationIconHover, theme.palette.primary.main)} 
                        onMouseOut={(e) => this.state.showContent === 'negotiation' ? this.changeColor(e, negotiationIconHover, theme.palette.primary.main) : this.changeColor(e, negotiationIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'negotiation' ? classNames(classes.selected, classes.hoverLI) : classNames(classes.hoverLI, classes.borderTopClosed)} 
                        onClick={this.showNegotiation} style={borderColor}>
                    <ListItemIcon>
                      <img src={this.state.showContent === 'negotiation' ? negotiationIconHover : negotiationIcon} alt='Negociação' className={classes.iconSize} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Negociação - CF' style={{color: this.state.showContent === 'negotiation' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>
                </Tooltip>
                : null}

              {this.props.roleTypes.indexOf(FP_GROUP) > -1 || this.props.roleTypes.indexOf(FP_NEGOTIATION_GROUP) > -1 || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 ?
                <React.Fragment>
                  <Tooltip key={0} title='Compras Firmes' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                    <ListItem onMouseOver={(e) => this.changeColor(e, firmPurchasesIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'firmPurchases' ? this.changeColor(e, firmPurchasesIconHover, theme.palette.primary.main) : this.changeColor(e, firmPurchasesIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'firmPurchases' ? classNames(classes.selected, classes.hoverLI) : classes.hoverLI} 
                        onClick={this.showFirmPurchases} style={borderColor}>
                      <ListItemIcon>
                        <img src={this.state.showContent === 'firmPurchases' ? firmPurchasesIconHover : firmPurchasesIcon} alt='Compras Firmes' className={classes.iconSize} />
                      </ListItemIcon>
                      <ListItemText disableTypography primary='Compras Firmes' style={{color: this.state.showContent === 'firmPurchases' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItem>
                  </Tooltip>
                  <Tooltip key={1} title='Transporte Compras Firmes' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                    <ListItem onMouseOver={(e) => this.changeColor(e, transportIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'transports' ? this.changeColor(e, transportIconHover, theme.palette.primary.main) : this.changeColor(e, transportIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'transports' ? classNames(classes.selected, classes.hoverLI) : classes.hoverLI} 
                        onClick={this.showTransports} style={borderColor}>
                      <ListItemIcon>
                        <img src={this.state.showContent === 'transports' ? transportIconHover : transportIcon} alt='Transportes' className={classes.iconSize} />
                      </ListItemIcon>
                      <ListItemText disableTypography primary='Transportes - CF' style={{color: this.state.showContent === 'transports' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItem>
                  </Tooltip>
                </React.Fragment>
                : null}

              {this.props.roleTypes.indexOf(FP_COMMERCIAL_GROUP) > -1 || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 ?
                <Tooltip title='Reservas Compras Firmes' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                  <ListItem onMouseOver={(e) => this.changeColor(e, reservationsIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'reservations' ? this.changeColor(e, reservationsIconHover, theme.palette.primary.main) : this.changeColor(e, reservationsIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'reservations' ? classNames(classes.selected, classes.hoverLI) : classes.hoverLI} 
                        onClick={this.showReservations} style={borderColor}>
                    <ListItemIcon>
                      <img src={this.state.showContent === 'reservations' ? reservationsIconHover : reservationsIcon} alt='ReservasComprasFirmes' className={classes.iconSize} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Reservas - CF' style={{color: this.state.showContent === 'reservations' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>
                </Tooltip>
                : null}

              {this.props.roleTypes.indexOf(UR_CREATION_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GROUP) > -1
                || this.props.roleTypes.indexOf(UR_COMMERCIAL_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GENERAL_GROUP) > -1 ?
                <React.Fragment>
                  {this.props.roleTypes.indexOf(FP_NEGOTIATION_GROUP) > -1 || this.props.roleTypes.indexOf(FP_GROUP) > -1 || this.props.roleTypes.indexOf(FP_COMMERCIAL_GROUP) > -1 || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 ?
                    <Divider key={0} className={this.state.open ? classes.menuDividerOpen : classes.menuDivider} variant='inset' component='li' />
                    : null}
                  <ListItem key={1} className={this.state.open ? '' : classes.hideTitle}>
                    <ListItemText disableTypography primary='Gestão de Renting Usados' className={this.state.open ? classes.textModuleTitle : classes.hideTitle} />
                  </ListItem>
                </React.Fragment>
                : null}

              {this.props.roleTypes.indexOf(UR_CREATION_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GENERAL_GROUP) > -1 ?
                <Tooltip title='Criação Renting Usados' placement='right' disableHoverListener={this.state.open} disableFocusListener={true} >
                  <ListItem onMouseOver={(e) => this.changeColor(e, negotiationIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'creationUsedRentals' ? this.changeColor(e, negotiationIconHover, theme.palette.primary.main) : this.changeColor(e, negotiationIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'creationUsedRentals' ? classNames(classes.selected, classes.hoverLI) : classNames(classes.hoverLI, classes.borderTopClosed)} 
                        onClick={this.showCreationUsedRentals} style={borderColor}>
                    <ListItemIcon>
                      <img src={this.state.showContent === 'creationUsedRentals' ? negotiationIconHover : negotiationIcon} alt='CriacaoRentingUsados' className={classes.iconSize} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Criação - RU' style={{color: this.state.showContent === 'creationUsedRentals' ? theme.palette.primary.main : "#ffffff"}}  />
                  </ListItem>
                </Tooltip>
                : null}

              {this.props.roleTypes.indexOf(UR_GROUP) > -1 || this.props.roleTypes.indexOf(UR_CREATION_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GENERAL_GROUP) > -1 ?
                <React.Fragment>
                  <Tooltip key={0} title='Renting Usados' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                    <ListItem onMouseOver={(e) => this.changeColor(e, firmPurchasesIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'usedRentals' ? this.changeColor(e, firmPurchasesIconHover, theme.palette.primary.main) : this.changeColor(e, firmPurchasesIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'usedRentals' ? classNames(classes.selected, classes.hoverLI) : classNames(classes.hoverLI)} 
                        onClick={this.showUsedRentals} style={borderColor}>
                      <ListItemIcon>
                        <img src={this.state.showContent === 'usedRentals' ? firmPurchasesIconHover : firmPurchasesIcon} alt='Renting Usados' className={classes.iconSize} />
                      </ListItemIcon>
                      <ListItemText disableTypography primary='Renting Usados' style={{color: this.state.showContent === 'usedRentals' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItem>
                  </Tooltip>
                  <Tooltip key={1} title='Transporte Renting Usados' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                    <ListItem onMouseOver={(e) => this.changeColor(e, transportIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'transportsUsedRentals' ? this.changeColor(e, transportIconHover, theme.palette.primary.main) : this.changeColor(e, transportIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'transportsUsedRentals' ? classNames(classes.selected, classes.hoverLI) : classNames(classes.hoverLI)} 
                        onClick={this.showTransportsUsedRentals} style={borderColor}>
                      <ListItemIcon>
                        <img src={this.state.showContent === 'transportsUsedRentals' ? transportIconHover : transportIcon} alt='TransportesRentingUsados' className={classes.iconSize} />
                      </ListItemIcon>
                      <ListItemText disableTypography primary='Transportes - RU' style={{color: this.state.showContent === 'transportsUsedRentals' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItem>
                  </Tooltip>
                </React.Fragment>
                : null}

              {this.props.roleTypes.indexOf(UR_COMMERCIAL_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GENERAL_GROUP) > -1 ?
                <Tooltip title='Reservas Renting Usados' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                  <ListItem onMouseOver={(e) => this.changeColor(e, reservationsRUIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'reservationsUsedRentals' ? this.changeColor(e, reservationsRUIconHover, theme.palette.primary.main) : this.changeColor(e, reservationsRUIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'reservationsUsedRentals' ? classNames(classes.selected, classes.hoverLI) : classNames(classes.hoverLI)} 
                        onClick={this.showReservationsUsedRentals} style={borderColor}>
                    <ListItemIcon>
                      <img src={this.state.showContent === 'reservationsUsedRentals' ? reservationsRUIconHover : reservationsRUIcon} alt='ReservasRentingUsados' className={classes.iconSize} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Reservas - RU' style={{color: this.state.showContent === 'reservationsUsedRentals' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>
                </Tooltip>
                : null}

              {this.props.roleTypes.indexOf(REPORTS_GROUP) > -1 || this.props.roleTypes.indexOf(ADMIN_GROUP) > -1
                || this.props.roleTypes.indexOf(FP_COMMERCIAL_GROUP) > -1 || this.props.roleTypes.indexOf(UR_COMMERCIAL_GROUP) > -1
                || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GENERAL_GROUP) > -1 ?
                <React.Fragment>
                  <Divider key={0} className={this.state.open ? classes.menuDividerOpen : classes.menuDivider} variant='inset' component='li' />
                  <ListItem key={1} className={this.state.open ? '' : classes.hideTitle}>
                    <ListItemText disableTypography primary='Funcionalidades Gerais' className={this.state.open ? classes.textModuleTitle : classes.hideTitle} />
                  </ListItem>
                </React.Fragment>
                : null}

              {this.props.roleTypes.indexOf(REPORTS_GROUP) > -1 || this.props.roleTypes.indexOf(REPORTS_GLOBAL_GROUP) > -1
                || this.props.roleTypes.indexOf(FP_COMMERCIAL_GROUP) > -1 || this.props.roleTypes.indexOf(UR_COMMERCIAL_GROUP) > -1
                || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GENERAL_GROUP) > -1 ?
                <Tooltip title='Relatórios' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                  <ListItem onMouseOver={(e) => this.changeColor(e, reportsIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'reports' ? this.changeColor(e, reportsIconHover, theme.palette.primary.main) : this.changeColor(e, reportsIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'reports' ? classNames(classes.selected, classes.hoverLI) : classNames(classes.hoverLI, classes.borderTopClosed)} 
                        onClick={this.showReports} style={borderColor}>
                    <ListItemIcon>
                      <img src={this.state.showContent === 'reports' ? reportsIconHover : reportsIcon} alt='Relatórios' className={classes.iconSize} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Relatórios' style={{color: this.state.showContent === 'reports' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>
                </Tooltip>
                : null}

              {this.props.roleTypes.indexOf(FP_NEGOTIATION_GROUP) > -1 || this.props.roleTypes.indexOf(FP_GROUP) > -1
                || this.props.roleTypes.indexOf(FP_COMMERCIAL_GROUP) > -1 || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 ?
                <Tooltip title='Audit SalesForce -> BM' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                  <ListItem onMouseOver={(e) => this.changeColor(e, auditIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'auditSFBM' ? this.changeColor(e, auditIconHover, theme.palette.primary.main) : this.changeColor(e, auditIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'auditSFBM' ? classNames(classes.selected, classes.hoverLI) : classNames(classes.hoverLI, classes.borderTopClosed)}
                        onClick={this.showAuditSFBM} style={borderColor}>
                    <ListItemIcon>
                      <img src={this.state.showContent === 'auditSFBM' ? auditIconHover : auditIcon} alt='audit_SFBM' className={classes.iconSize} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Audit SalesForce -> BM' style={{color: this.state.showContent === 'auditSFBM' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>
                </Tooltip>
                : null}
              {this.props.roleTypes.indexOf(FP_NEGOTIATION_GROUP) > -1 || this.props.roleTypes.indexOf(FP_GROUP) > -1
                || this.props.roleTypes.indexOf(FP_COMMERCIAL_GROUP) > -1 || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 ?
                <Tooltip title='Audit BM -> SalesForce' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                  <ListItem onMouseOver={(e) => this.changeColor(e, auditIconHover, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'auditBMSF' ? this.changeColor(e, auditIconHover, theme.palette.primary.main) : this.changeColor(e, auditIcon, "#ffffff")} 
                        divider button className={this.state.showContent === 'auditBMSF' ? classNames(classes.selected, classes.hoverLI) : classNames(classes.hoverLI, classes.borderTopClosed)} 
                        onClick={this.showAuditBMSF} style={borderColor}>
                    <ListItemIcon>
                      <img src={this.state.showContent === 'auditBMSF' ? auditIconHover : auditIcon} alt='audit_BMSF' className={classes.iconSize} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Audit BM -> SalesForce' style={{color: this.state.showContent === 'auditBMSF' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>
                </Tooltip>
                : null}

              {this.props.roleTypes.indexOf(ADMIN_GROUP) > -1 || this.props.roleTypes.indexOf(GENERAL_GROUP) > -1 || this.props.roleTypes.indexOf(UR_GENERAL_GROUP) > -1 ?
                <Tooltip title='Administração' placement='right' disableHoverListener={this.state.open} disableFocusListener={true}>
                  <ListItem onMouseOver={(e) => this.changeColorAdmin(e, adminIconHover, theme.palette.primary.main, 'primary', false, true)}
                        onMouseOut={(e) => this.state.showContent.indexOf('admin') !== -1 ? this.changeColorAdmin(e, adminIconHover, theme.palette.primary.main, 'primary', false, false) : this.changeColorAdmin(e, adminIcon, "#ffffff", 'secondary', true, false)} 
                        divider button className={this.state.showContent.indexOf('admin') !== -1 ? classNames(classes.selected, classes.hoverLI) : classNames(classes.hoverLI)} 
                        onClick={this.handleChangeAdminList} style={borderColor}>
                    <ListItemIcon>
                      <img src={this.state.showContent.indexOf('admin') !== -1 ? adminIconHover : adminIcon} alt='Administração' className={classes.iconSize} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Administração' style={{color: this.state.showContent.indexOf('admin') !== -1 ? theme.palette.primary.main : "#ffffff"}} />
                    {this.state.openAdminList ? <ExpandLess color={this.state.clickAdmin || this.state.showContent.indexOf('admin') !== -1 ? 'primary' : 'secondary'} /> : <ExpandMore color={this.state.clickAdmin || this.state.showContent.indexOf('admin') !== -1 ? 'primary' : 'secondary'} />}
                  </ListItem>
                </Tooltip>
                : null}

              <Collapse in={this.state.openAdminList} timeout='auto' unmountOnExit>
                <List component='div' disablePadding>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminBrandModel' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminBrandModel' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} 
                        onClick={this.showAdminBrandModel}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminBrandModel' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Marcas / Modelos' style={{color: this.state.showContent === 'adminBrandModel' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminSaleChannel' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminSaleChannel' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} 
                        onClick={this.showAdminSaleChannel}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminSaleChannel' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Canais de Venda' style={{color: this.state.showContent === 'adminSaleChannel' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminDiscounts' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminDiscounts' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} 
                        onClick={this.showAdminDiscounts}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminDiscounts' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Descontos' style={{color: this.state.showContent === 'adminDiscounts' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminOptionals' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminOptionals' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} 
                        onClick={this.showAdminOptionals}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminOptionals' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Opcionais' style={{color: this.state.showContent === 'adminOptionals' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminGeneralDefinitions' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminGeneralDefinitions' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} 
                        onClick={this.showAdminGeneralDefinitions}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminGeneralDefinitions' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Definições Gerais' style={{color: this.state.showContent === 'adminGeneralDefinitions' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminHolidays' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminHolidays' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} 
                        onClick={this.showAdminHolidays}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminHolidays' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Feriados' style={{color: this.state.showContent === 'adminHolidays' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminColors' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminColors' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} 
                        onClick={this.showAdminColors}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminColors' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Cores' style={{color: this.state.showContent === 'adminColors' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>
                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminColorsSF' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminColorsSF' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} onClick={this.showAdminColorsSF}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminColorsSF' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Cores SalesForce' style={{color: this.state.showContent === 'adminColorsSF' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminExtension' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminExtension' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} onClick={this.showAdminExtension}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminExtension' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Motivos Prolongamento' style={{color: this.state.showContent === 'adminExtension' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminCancellation' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminCancellation' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} onClick={this.showAdminCancellation}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminCancellation' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='Motivos Cancelamento' style={{color: this.state.showContent === 'adminCancellation' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>

                  <ListItem onMouseOver={(e) => this.changeColorText(e, theme.palette.primary.main)}
                        onMouseOut={(e) => this.state.showContent === 'adminSalesForceSync' ? this.changeColorText(e, theme.palette.primary.main) : this.changeColorText(e, "#ffffff")} 
                        button className={this.state.showContent === 'adminSalesForceSync' ? classNames(classes.nested, classes.selected, classes.hoverLI) : classNames(classes.nested, classes.hoverLI)} onClick={this.showAdminSalesForceSync}>
                    <ListItemIcon>
                      <LineIcon style={{color: this.state.showContent === 'adminSalesForceSync' ? theme.palette.primary.main : "#ffffff"}} />
                    </ListItemIcon>
                    <ListItemText disableTypography primary='SalesForce Queue e Sync' style={{color: this.state.showContent === 'adminSalesForceSync' ? theme.palette.primary.main : "#ffffff"}} />
                  </ListItem>
                </List>
              </Collapse>

            </div>
          </List>

        </Drawer>

        <main className={classes.content}>
          <div className={classNames(classes.toolbar, classes.toolbarHeight)} />
          {content}
        </main>

      </div>
    );
  }
}

GCFMainApp.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  ...state,
});
const mapDispatchToProps = dispatch => ({
  logOut: () => dispatch(logOut())
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(GCFMainApp));


// WEBPACK FOOTER //
// ./src/components/GCFMainApp.js